module.exports = __webpack_public_path__ + "img/record.c085723f.jpg";